import { logoStyles } from "@insite/content-library/Widgets/Basic/Logo";
import { bannerStyles } from "@insite/content-library/Widgets/Category/CategoryDetailBanner";
import { css } from "styled-components";

Object.assign(bannerStyles, {
    ...bannerStyles,
    container: {
        css: css`
            table {
                margin-bottom: 30px;
            }

            tr > td > ul {
                margin: 0;

                li > a > span,
                li {
                    font-size: 14px;
                }
            }
            li {
                font-size: 14px;
            }
        `,
    },
});
